import { Link } from "react-router-dom";
import { connect } from "react-redux";

var CurrentUser = require("lib/account/CurrentUser");
var Features = require("lib/account/Features");
var QuestionTypes = require("lib/academic/QuestionTypes");
var DataRouting = require("lib/routing/DataRouting");

var WritingSelectors = require("lib/selectors/WritingSelectors");
var WritingActions = require("lib/actions/WritingActions");
var MultiPartAnswerDisplay = require("components/writing/answers/MultiPartAnswerDisplay");
var MultiPartSentenceStarter = require("components/writing/questions/MultiPartSentenceStarter");
var BookDisplay = require("components/reading/books/BookDisplay")
var CoinsEarnedDisplay = require("components/reading/shelves/CoinsEarnedDisplay");
var Glyphicon = require("components/utility/icons/Glyphicon");
var StudentDisplay = require("components/users/students/StudentDisplay");
var ScoreDisplay = require("components/writing/evaluations/ScoreDisplay");
var DisplayToggleControl = require("components/utility/DisplayToggleControl")
var EditControls = require("components/writing/controls/EditControls");
var AnalysisControls = require("components/writing/controls/AnalysisControls");
var FeedbackControls = require("components/writing/controls/FeedbackControls");

var AnswerScoringDetails = require("components/writing/answers/AnswerScoringDetails");

var CommentBox = require("components/social/comments/CommentBox");
var ReactTooltip = require("react-tooltip");

var Skillsets = require("lib/academic/Skillsets");
var RosterSelectors = require("lib/selectors/RosterSelectors");

var UIActions = require("lib/actions/UIActions");
var WritingActions = require("lib/actions/WritingActions");



require("writing/answers/answer_display.scss");

@connect(
	(state, props) => {
		var answer = WritingSelectors.answer({ state, id: props.answerID });
		var passProps = {
			answer: answer
		}

		if (answer) {
			passProps.question = WritingSelectors.question({ state, id: answer.question_id });
			var student = RosterSelectors.student({ state, id: answer.user_id });

			if (answer.evaluation) {
				var evaluation = WritingSelectors.evaluation({ state, id: answer.evaluation})
				if (evaluation) {
					passProps.evaluation = evaluation
				}
			}
		}

		if (student) {
			passProps.studentReadingLevel = student.current_reading_level;
		}

		passProps.blockComments = !Features.isEnabled(Features.TEACHER_COMMENTS);
		return passProps;
	}, 
	(dispatch, props) => ({
		// fetches autograder data
		fetchEvaluations: (answerID) => {
			dispatch(WritingActions.fetchEvaluations({
				filters: { subject_type: 'Answer', subject_id: answerID },
				embeds: ["evaluation.autograder_data", "evaluation.score_details"]
			}))
		},
		updateEvaluation: (evaluationID, update) => {
			dispatch(WritingActions.updateEvaluation({ id: evaluationID, update }))
		},
		skipRevision: () => {
			return dispatch(WritingActions.updateAnswer({
				id: props.answerID, update: { allow_revision: false }, query: { skip: true }
			})).then(() => {
				CurrentUser.fetchCurrentUserCoinData();
			})
		}
	})
)
class AnswerDisplay extends React.Component {
	constructor(props) {
		super();
		autobind(this);
		this.state = {
			controlMode: props.controlMode ? props.controlMode : null
		}
	}

	handleExcludedPunctuation(answerString, command) {
		var loopCount = 0
		var returnString = _.clone(answerString)
		_.each(EXCLUDED_PUNCTUATION, (punct) => {
			loopCount += 1
			if (command === 'add-spaces') {
				returnString = _.include(NO_PRECEDING_SPACE, punct) ? returnString.replaceAll(punct, ' ' + punct) : returnString.replaceAll(punct, punct + ' ')
			} else if (command === 'remove-spaces') {
				returnString = _.include(NO_PRECEDING_SPACE, punct) ? returnString.replaceAll(' ' + punct, punct) : returnString.replaceAll(punct + ' ', punct)
			}
		})
		if (loopCount === _.size(EXCLUDED_PUNCTUATION)) {
			return returnString
		}
	}

	controlMode() {
		return this.state.controlMode;
	}

	onModeChange(controlMode) {
		this.setState({ controlMode }, () => {
			var { evaluation, answer } = this.props
			if (controlMode == ANALYSIS_CONTROLS || controlMode == EDIT_CONTROLS) {
				this.updateEvaluationAsViewed()
				// fetches autograder data
				if (answer.id && (!evaluation || !evaluation.autograder_data) && !CurrentUser.isStudent()) {
					this.props.fetchEvaluations(answer.id)
				}
			}
		});

		setTimeout($wr.triggerResize, 400);
		
		if (this.props.onModeChange) {
			this.props.onModeChange(controlMode)
		}
	}
	closeControl(e) {
		if (this.props.onCloseControl) {
			this.props.onCloseControl(e);
		} else {
			$wr.nope(e);
			this.setState({ controlMode: null });			
		}
	}

	// Updates evaluation as viewed
	updateEvaluationAsViewed() {
		var { evaluation } = this.props
		var { controlMode } = this.state

		if (evaluation && !evaluation.viewed && (controlMode == ANALYSIS_CONTROLS || controlMode == EDIT_CONTROLS) && !CurrentUser.isStudent()) {
			this.props.updateEvaluation(evaluation.id, { viewed: true })
		}
	}

	onSkipRevision() {
		if (confirm("Are you sure?")) {
			this.props.skipRevision();
		}
	}

	isReview() {
		return this.props.answer.question_type == QuestionTypes.REVIEW_QUESTION;
	}
	isFillInTheBlank() {
		return this.props.answer.question_type == "fill-in-the-blank-question";
	}
	isMetaCognitive() {
		return this.props.answer.question_type == QuestionTypes.META_COGNITIVE_QUESTION;
	}
	displayScore() {
		return !this.isMetaCognitive() && !this.isReview()
	}

	toggleEdit() {
		this.props.onEditEvaluation()
	}

	noun() {
		if (this.isReview()) {
			return "review";
		} else if (this.isMetaCognitive()) {
			return 'question builder'
		} else {
			return "answer";
		}
	}

	resumePath() {
		var answer = this.props.answer;

		if (this.isReview()) {
			return "/reviews/new?text_id=" + answer.text_id + "&answer_id=" + answer.id;
		} else if (this.isMetaCognitive()) {
			return "/question_builder/new?text_id=" + answer.text_id + "&answer_id=" + answer.id;
		} else {
			return "/answers/new?text_id=" + answer.text_id + "&answer_id=" + answer.id;
		}
	}

	answerKeyActive() {
		return !!(
			(this.props.enabled.answerKey || (this.controlMode() === ANALYSIS_CONTROLS)) &&
			this.isFillInTheBlank() &&
			this.props.question &&
			this.props.question.answer_options
		);
	}

	renderAnswerKey() {
		var textPart = _.findWhere(this.props.answer.parts, { type: MultiPartSentenceStarter.BODY });

		if (textPart && textPart["match"] !== undefined) {
			if (textPart["match"] == 1) {
				var statusDisplay = (
					<span className="matchStatus correct">
						<Glyphicon icon="ok" /> Correct
					</span>
				);
			} else {
				var statusDisplay = (
					<span className="matchStatus incorrect">
						<Glyphicon icon="remove" /> Incorrect
					</span>
				);
			}

			if (this.props.question) {
				var keyOptions = (
					<span>
						Answer Key: { this.props.question.answer_options.join(", ") }
					</span>
				)
			}

			return (
				<div className="answerKey">
					{ statusDisplay }
					{ keyOptions }
				</div>
			)
		}
	}

	renderFirstRow() {
		var { enabled, answer } = this.props;

		if (enabled.student) {
			var studentDisplay = (
				<StudentDisplay studentID={ answer.user_id } showAvatar avatarMaxWidth={ 40 } />
			)
		}

		if (enabled.date) {
			var dateDisplay = (
				<div className="date">
					{ $wr.formatDateTime(answer.completed_at, "show-past-years") }
				</div>
			)
		}

		if (answer.quiz_id && enabled.linkToQuiz) {
			var quizPath = DataRouting.getPath({
				subjectType: DataRouting.SUBJECT_QUIZZES,
				textID: answer.text_id,
				userIDs: [answer.user_id]
			});

			var quizLink = (
				<Link to={ quizPath } className="hideOnPrint linkToQuiz"
					onClick={ () => $wr.setWindowY(0) }
					data-tip data-for="quizLink">

					<Glyphicon icon="link" />
					<ReactTooltip effect="solid" id="quizLink">
						<span>This answer is part of a quiz. Click to view the quiz.</span>
					</ReactTooltip>
				</Link>
			);
		}

		if (enabled.score && !answer.quiz_id && this.displayScore()) {
			var scoreDisplay = (
				<ScoreDisplay showDenominator subjectID={ answer.id }
					subjectType={ "Answer" } mode={ ScoreDisplay.CIRCLE_MODE } />
			);
		}

		if (answer.draft) {
			var draftText = (
				<span>
					This { this.noun() } isn't done. <Link className="finishAnswer" to={ this.resumePath() }>
					Finish { this.noun() }</Link>!
				</span>
			);
		}

		if ((enabled.startRevision || enabled.cancelRevision) && answer.allow_revision) {
			if (enabled.startRevision) {
				var goToRevision = (
					<Link className="btn buttonPrimary revisionButton" to={ this.resumePath() }>
						Start Revision
					</Link>
				);
			}

			if (enabled.cancelRevision) {
				var cancelRevision = (
					<button className="btn btn-default revisionButton"
						onClick={ this.onSkipRevision }>
						Skip
					</button>
				);
			}

			var revisionButtons = (
				<div>
					<p>Your teacher will let you revise this answer.</p>
					{ goToRevision }
					{ cancelRevision }
				</div>
			);
		}

		var displayPresentClass = enabled.bookDisplayPresent ? '' : 'noBookDisplay'

		if (draftText || studentDisplay || dateDisplay || scoreDisplay || quizLink) {
			return (
				<div className={ "answerDisplayRow topRow clearfix " + displayPresentClass }>
					<div className="pull-left">
						{ revisionButtons }
						{ studentDisplay }
						{ draftText }
					</div>
					<div className="pull-right">
						{ dateDisplay }
						{ scoreDisplay }
						{ quizLink }
					</div>
				</div>
			)
		}
	}

	renderSecondRow() {
		var { enabled, answer } = this.props;

		if (enabled.textTitle) {
			var bookDisplay = (
				<BookDisplay inline textID={ answer.text_id }
					showReadingLevel={ enabled.readingLevel }
					studentReadingLevel={this.props.studentReadingLevel}
					showCover={true}
				/>
			)
		}

		var toggleOptions = [];

		if (enabled.editControls) {
			toggleOptions.push({
				key: EDIT_CONTROLS,
				text: EDIT_CONTROLS
			})
		}

		if (enabled.feedbackControls) {
			toggleOptions.push({
				key: FEEDBACK_CONTROLS,
				text: FEEDBACK_CONTROLS
			})
		}

		if (enabled.analysisControls) {
			toggleOptions.push({
				key: ANALYSIS_CONTROLS,
				text: ANALYSIS_CONTROLS
			})
		}

		if (toggleOptions.length) {
			var controlToggle = (
				<div className="hideOnPrint">
					<DisplayToggleControl options={ toggleOptions }
						mode={ DisplayToggleControl.LINK_MODE }
						onChange={ this.onModeChange } activeOptionKey={ this.controlMode() } />
				</div>
			);
		}

		if (enabled.coinsEarned) {
			var coinsEarned = (
				<CoinsEarnedDisplay key={ answer.id } subjectType="Answer" subjectID={ answer.id } />
			);
		}

		if (bookDisplay || controlToggle) {
			return (
				<div key={answer.id + '_answerDisplayRow'} className="answerDisplayRow secondRow clearfix">
					<div className="pull-left">
						{ coinsEarned }{ bookDisplay }
					</div>
					<div className="pull-right">
						{ controlToggle }
					</div>
				</div>
			)
		}
	}

	renderComments() {
		var { answer, enabled } = this.props;

		if (enabled.lowerComments) {
			if (answer.quiz_id) {
				var subjectType = "QuizAnswer";
			} else if (answer.question_type == QuestionTypes.META_COGNITIVE_QUESTION) {
				var subjectType = "JournalActivityQuestionBuilder";
			} else if (answer.question_type == QuestionTypes.REVIEW_QUESTION) {
				var subjectType = "JournalActivityReview";
			} else {
				var subjectType = "JournalActivityAnswer";
			}

			return (
				<CommentBox subjectID={ answer.id }
					subjectType={ subjectType }
					userID={ answer.user_id }
					blockFirstComment={ true }
					initialCollapsed={ false } />
			)
		}
	}

 setCharAt(str, index, chr) {
	if (index > str.length - 1) return str;
	return str.substring(0, index) + chr + str.substring(index + 1);
}

	render() {
		var { answer, question, enabled } = this.props;

		var className = "answerDisplay writingDisplay clearfix";

		if (answer && answer.draft) {
			className += " asDraft";
		}

		if (!this.isFillInTheBlank() && !this.isMetaCognitive()) {
			var questionDisplay = (
				<p className="questionText">
					{ answer.question_text }
				</p>
			);
		}

		if (this.isFillInTheBlank()) {
			var answerBody = (
				<div className="answerText">
					<MultiPartAnswerDisplay parts={answer.parts} emphasizeInputs />
				</div>
			);

			className += " forFITB";
		}
		else if (this.isMetaCognitive()) {
			// remove answer from question text
			var parts = _.clone(answer.parts)
			var questionPart = _.clone(_.findWhere(parts, { type: QUESTION_TYPE }))
			var answerPart = _.clone(_.findWhere(parts, { type: ANSWER_TYPE }))
			var synonymParts = _.clone(_.filter(parts, (part) => { return part.type.includes(SYNONYM_TYPE) }))
	
			if (!answer.draft && questionPart && answerPart) {
				var questionString = _.clone(questionPart.text) || ''
				var answerString = _.clone(answerPart.text) || ''
				// add multiple blanks for answers with multiple words
				if (answerPart.index && parseInt(answerPart.index)) {
					var startIndex = parseInt(answerPart.index)
					var numOfWords = this.handleExcludedPunctuation(answerString, 'add-spaces').split(/\s+/).length
					var questionStringArray = this.handleExcludedPunctuation(questionString, 'add-spaces').split(/\s+/)
					// manipulate question string
					var loopIndex = 0
					while (loopIndex < numOfWords) {
						if (_.include(EXCLUDED_PUNCTUATION, questionStringArray[startIndex + loopIndex])) {
							numOfWords++
						} else {
							questionStringArray[startIndex + loopIndex] = '____'
						}
						loopIndex++
					}
					
					var updatedQuestion = this.handleExcludedPunctuation(questionStringArray.join(' '), 'remove-spaces')
				} else {
					var updatedQuestion = questionString.replace(answerString, '____')
				}

				var synonymPart = {}
				if (synonymParts.length) {
					synonymPart.type = SYNONYM_TYPE
					_.each(synonymParts, function (synonymObj, i) {
						synonymPart[i] = synonymObj.text
					})
				}

				questionPart.text = updatedQuestion
				parts = { questionPart, answerPart, synonymPart }
			}
			
				var answerBody = (
					<div className="answerText">
						<MultiPartAnswerDisplay parts={parts} metaCognitive />
					</div>
				);

				className += " forFITB";
			
		}
		else {
			if (this.controlMode() == ANALYSIS_CONTROLS || this.controlMode() == EDIT_CONTROLS) {
				if (this.props.evaluation && this.props.evaluation.autograder_data) {
					var answerBody = (
						<div className={`answerText ${this.controlMode() == EDIT_CONTROLS ? 'editMode' : ''}`}>
							<AnswerScoringDetails editMode={this.controlMode() == EDIT_CONTROLS} onModeChange={this.onModeChange} answer={this.props.answer} />
						</div>
					);
				} else {
					var answerBody = (
						<div>
							<div className="answerText">
								<MultiPartAnswerDisplay parts={ answer.parts } breakSections />
							</div>
							<p className="text-center missingEvaluation">
								Scoring details are unvailable for this answer.
							</p>
						</div>
					);
				}
			} else {
				var answerBody = (
					<div className="answerText">
						<MultiPartAnswerDisplay parts={ answer.parts } breakSections />
					</div>
				);
			}

			className += " nonFITB";
		}

		if (this.answerKeyActive()) {
			var answerKey = this.renderAnswerKey();
		}

		var innerStyle = {};

		if (this.controlMode()) {
			className += " withControl";

			var controlEnabled = _.pick(this.props.enabled,
				"allowRevision", "editScore", "deletion", "toggleInclude"
			)

			if (this.props.controlContent !== undefined) {
				var innerControl = this.props.controlContent

			} else if (this.controlMode() === EDIT_CONTROLS) {
				var innerControl = (
					<EditControls answerID={ answer.id } enabled={ controlEnabled } />
				);

			} else if (this.controlMode() === FEEDBACK_CONTROLS) {
				var innerControl = (
					<FeedbackControls answerID={ answer.id } enabled={ controlEnabled } />
				);

			} else if (this.controlMode() === ANALYSIS_CONTROLS) {
				var innerControl = (
					<AnalysisControls answerID={ answer.id } enabled={ controlEnabled } />
				);
			}

			if (this.props.answer && this.props.answer.quiz_id) { // If it's coming from the quiz
				className += " withUpperControl";
			}

			if (!this.props.suppressControlHeader) {
				var controlClose = (
					<a href="#" onClick={ this.closeControl } className="removeLink">
						<Glyphicon icon="remove" />
					</a>
				);
				var controlTitle = (
					<div className="controlTitle">
						{ this.controlMode() }
					</div>
				);
			}

			var controlBox = (
				<div className="controlBox">
					{ controlClose }
					{ controlTitle }
					{ innerControl }
				</div>
			);
		}

		return (
			<div className={ className }>
				{ this.renderFirstRow() }
				{ this.renderSecondRow() }

				<div className="innerWrap">
					<div className="innerAnswer" style={ innerStyle }>
						{ questionDisplay }
						{ answerBody }
						{ answerKey }

						{ this.renderComments() }
					</div>

					{ controlBox }
				</div>
			</div>
		);
	}

	componentDidMount() {
		this.updateEvaluationAsViewed()
	}

	componentDidUpdate(prevProps) {		
		var { controlMode } = this.props
		if (!prevProps || prevProps.controlMode !== controlMode) {
			this.setState({ controlMode }, () => this.updateEvaluationAsViewed())
		}
	}
}

AnswerDisplay.QUIZZES_VIEW = "quizzes";
AnswerDisplay.ANSWERS_VIEW = "answers";
AnswerDisplay.REVIEWS_VIEW = "reviews";

var EDIT_CONTROLS = "Edit";
var FEEDBACK_CONTROLS = "Feedback";
var ANALYSIS_CONTROLS = "Analysis";

var QUESTION_TYPE = "question"
var ANSWER_TYPE = "answer"
var SYNONYM_TYPE = "synonym"

var EXCLUDED_PUNCTUATION = [',', '.', '!', '?', ';', ')', '(']
var NO_PRECEDING_SPACE = [',', '.', '!', '?', ';', ')']

AnswerDisplay.EDIT_CONTROLS = EDIT_CONTROLS;
AnswerDisplay.FEEDBACK_CONTROLS = FEEDBACK_CONTROLS;
AnswerDisplay.ANALYSIS_CONTROLS = ANALYSIS_CONTROLS;

AnswerDisplay.defaultProps = {
  enabled: {}
}

AnswerDisplay.WrappedComponent.propTypes = StrictPropTypes({
	// ID of the answer to be displayed
	answerID: PropTypes.number.isRequired,

	// Fetches autograder data
	fetchEvaluations: PropTypes.func,

	// Updates evaluation as viewed
	updateEvaluation: PropTypes.func,

	// QuizDisplay can control our mode from above
	controlMode: PropTypes.string,

	// QuizDisplay can also override what shows in the quiz control box
	controlContent: PropTypes.object,

	// QuizDisplay suppress this section showing a title / close button
	suppressControlHeader: PropTypes.bool,

	// QuizDisplay can provide its own close control handler
	onCloseControl: PropTypes.func,
	onModeChange: PropTypes.func,

	// Former "show" props
	// 
	// "enabled" keys used in *this (answer)* component
	//   date 					-> shows date
	//   student 				-> shows student + avatar
	//   score 					-> shows the scoring circle in the upper right
	//   linkToQuiz				-> shows the scoring circle in the upper right
	//   textTitle 				-> shows the title of the book
	//   readingLevel 			-> shows the reading level of the book
	//   editControls			-> shows the controls to toggle into edit mode
	//   feedbackControls		-> shows the controls to toggle into feedback mode
	//   analysisControls		-> shows the controls to toggle into analysis model
	//   lowerComments			-> shows the comments UNDER the answer (not in feedback window)
	//   answerKey 				-> (FitB only) Show correct answers. Also triggered by edit mode
	// 	 coinsEarned			-> Shows how many coins were earned for the answer
	//   startRevision			-> Shows a button to begin the revision
	//   cancelRevision			-> Shows a button to decline doing a revision
	// 
	// Values passed on to the *control* components
	//   allowRevision			-> Allows student to retake answer
	//   editScore				-> Changes the score
	//   deletion 				-> Deletes the answer
	//   toggleInclude			-> Passed from answers -> controls
	//   
	enabled: PropTypes.object,

	// Changes the way the drafts show
	asDraft: PropTypes.bool,

	// From @connect
	// Which are present is determined by the other props
	answer: PropTypes.object.isRequired,
	question: PropTypes.object,

	// From @connect, paywall related
	blockComments: PropTypes.bool,

	// Expand comments to be shown for students
	viewAsStudent: PropTypes.bool,

	view: PropTypes.string,
	studentReadingLevel: PropTypes.number,
	exclude: PropTypes.bool,
	bookDisplayPresent: PropTypes.bool,
	evaluation: PropTypes.object,

	skipRevision: PropTypes.func
});

module.exports = AnswerDisplay



// WEBPACK FOOTER //
// ./modules/components/writing/answers/AnswerDisplay.js